"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var BirthStatusOption = /** @class */ (function (_super) {
    __extends(BirthStatusOption, _super);
    function BirthStatusOption(props) {
        var _this = _super.call(this, props) || this;
        _this.key = "";
        _this.state = {
            value: "",
            error: []
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            var number = _this.props.number;
            if (_this._isMounted) {
                var state = form_store_1.default.getState();
                _this.setState({
                    value: state.data[_this.key] || "",
                    error: state.error[_this.key] || []
                });
            }
        });
        return _this;
    }
    BirthStatusOption.prototype.componentDidMount = function () {
        var number = this.props.number;
        this.key = "birth_status_option_".concat(number);
        this._isMounted = true;
        var state = form_store_1.default.getState();
        this.setState({
            value: state.data[this.key] || "",
            error: state.error[this.key] || []
        });
    };
    BirthStatusOption.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    BirthStatusOption.prototype.render = function () {
        var number = this.props.number;
        var _a = this.state, value = _a.value, error = _a.error;
        var errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        if (error.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, error[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("ul", { className: "input-list input-list--vertical" },
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-checkbox" },
                        react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: "birth_status_option_".concat(number), value: "1", checked: value.indexOf("1") > -1, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-checkbox__text" }, "\u826F\u597D"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-checkbox" },
                        react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: "birth_status_option_".concat(number), value: "2", checked: value.indexOf("2") > -1, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-checkbox__text" }, "\u8607\u751F"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-checkbox" },
                        react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: "birth_status_option_".concat(number), value: "3", checked: value.indexOf("3") > -1, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-checkbox__text" }, "NICU\u5165\u9662"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-checkbox" },
                        react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: "birth_status_option_".concat(number), value: "4", checked: value.indexOf("4") > -1, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-checkbox__text" }, "\u5947\u5F62"))),
                react_1.default.createElement("li", { className: "input-list__item" },
                    react_1.default.createElement("label", { className: "input-checkbox" },
                        react_1.default.createElement("input", { className: "input-checkbox__input", type: "checkbox", name: "birth_status_option_".concat(number), value: "5", checked: value.indexOf("5") > -1, onChange: input_actions_1.default.changeInput }),
                        react_1.default.createElement("span", { className: "input-checkbox__text" }, "\u969C\u5BB3"))))));
    };
    return BirthStatusOption;
}(react_1.Component));
exports.default = BirthStatusOption;
